<template>
  <nav
    class="navbar navbar-expand-lg navbar-light bg-light sticky-top d-print-none"
    style="overflow: visible"
  >
    <div class="container-fluid">
      <a class="navbar-brand" href="#">
        <img height="80px" width="120px" :src="appSettings.titleImageUrl" />
        {{ appSettings.title }}</a
      >
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ms-auto align-items-center">
          <!-- <li class="nav-item me-1 navbar-charms">
                        <div class="btn-group">
                            <div class="nav-link text-right me-2 p-0 d-flex align-items-center" href="#" id="charm1Dropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <alzata-icon size="lg" :icon="notifications.filter(x => !x.isRead).length > 0 ? 'fas/bell' : 'fal/bell']" />
                                <span class="badge rounded-pill bg-danger" v-if="notifications.filter(x => !x.isRead).length > 0">{{notifications.filter(x => !x.isRead).length}}</span>
                            </div>
                            <div class="dropdown-menu dropdown-menu-end" aria-labelledby="charm1Dropdown">
                                <a class="dropdown-item" href="#">Do Stuff</a>
                            </div>
                        </div>
                    </li> -->
          <li class="nav-item dropdown">
            <div
              class="nav-link dropdown-toggle text-right p-0 d-flex align-items-center"
              href="#"
              id="navbarDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <div
                class="text-end me-2"
                style="
                  display: inline-block;
                  vertical-align: text-top;
                  line-height: 1rem;
                "
              >
                <strong>{{ user.firstName }} {{ user.lastName }}</strong
                ><br />
                <small v-if="tenant">{{ tenant.name }}</small>
                <small v-if="!tenant">(Global)</small>
              </div>
              <div class="icon" v-if="user.profileImageUrl">
                <img
                  :src="user.profileImageUrl"
                  width="40"
                  style="border-radius: 20px"
                />
              </div>
            </div>
            <div
              class="dropdown-menu dropdown-menu-end"
              aria-labelledby="navbarDropdown"
            >
              <a
                v-if="tenants.length > 1"
                class="dropdown-item"
                href="#"
                @click="showSwitchTenantModal"
                >Switch To...</a
              >
              <a class="dropdown-item" href="#" @click="editProfile"
                >Edit Profile</a
              >
              <a class="dropdown-item" href="#" @click="handleLogOut"
                >Log Out</a
              >
            </div>
          </li>
        </ul>
      </div>
    </div>
    <alzata-dialog
      title="Switch to Tenant"
      ref="switchTenantModal"
      v-if="tenants && tenants.length > 1"
    >
      <div class="list-group">
        <a
          v-for="item in tenants"
          :key="item.id"
          href="#"
          class="list-group-item list-group-item-action"
          :class="item.id === tenant.id ? 'active disabled' : null"
          :aria-current="item.id === tenant.id"
          :aria-disabled="item.id === tenant.id"
          :tabindex="item.id === tenant.id ? -1 : null"
          @click="handleSwitchTenant(item.id)"
        >
          {{ item.name }}
          <span v-if="item.id === tenant.id" class="badge bg-light text-dark"
            >Current</span
          >
        </a>
      </div>
      <template v-slot:modal-footer>
        <button
          type="button"
          class="btn btn-secondary"
          @click="hideSwitchTenantModal"
        >
          Cancel
        </button>
      </template>
    </alzata-dialog>
  </nav>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "AlzataAppHeader",
  computed: mapState({
    user: (state) => state.iam.user,
    tenant: (state) => state.iam.tenant,
    tenants: (state) => state.iam.tenants || [],
    // notifications: state => state.notifications.notifications || [],
  }),
  methods: {
    async handleLogOut() {
      this.apiClient.logout();
      this.$router.push({ name: "alzata:account/login" });
    },
    async showSwitchTenantModal() {
      this.$refs["switchTenantModal"].show();
    },
    hideSwitchTenantModal() {
      this.$refs["switchTenantModal"].hide();
    },
    async handleSwitchTenant(tenantId) {
      this.switchTenant(tenantId);
      this.hideSwitchTenantModal();
    },
    editProfile() {
      this.$router.push({ name: "alzata:account/profile" });
    },
    ...mapActions("iam", ["switchTenant"]),
  },
};
</script>
